// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import App from './App'
import router from './router'
import store from './store'
import * as auth from './auth'
import { sync } from 'vuex-router-sync'
import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

Raven.config('https://6ea32d67d0da48f2940758e63402ce62@sentry.io/239626').addPlugin(RavenVue, Vue).install()

sync(store, router)
Vue.use(Vuetify)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  if (!auth.checkAuth() && (to.name !== 'auth')) {
    store.commit('auth/logout')
    next({
      name: 'auth'
    })
  } else {
    Raven.setUserContext({
      email: auth.tokenPayload('email')
    })
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  router,
  store,
  template: '<App/>',
  components: { App }
}).$mount('#app')

// router.beforeEach((to, from, next) => {
//   router.app.$store.commit('clearErrorMessage')
//   router.app.$store.commit('clearSuccessMessage')
//   next()
// })




// WEBPACK FOOTER //
// ./src/main.js